import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/profiles/Page";

export const PATH = "/vendors/settings/profiles";

const ProfileSetting: NextPage = () => (
	<>
		<NskHead title="プロフィール設定" />
		<VendorLayoutV2>
			<Component />
		</VendorLayoutV2>
	</>
);

export default ProfileSetting;
